export default __webpack_public_path__ + "static/img1-a3a3858a88fb6c58a0fa4a926dd81d71.png";